import React, {useEffect, useRef, useState} from 'react';
import MainLayout from "../../layouts/main";
import HelperService from "../../services/helper-service";
import Section from "../../components/section";
import {useFavouritesService} from "../../services/favourites-service";
import {useTrainerService} from "../../services/trainer-service";
import {useGlobalNotificationMessage} from "../../context/message";
import {Link, useParams} from "react-router-dom";
import InitialLoading from "../../components/initial-loading";
import StarRating from "../../components/star-rating";
import {AppEvents, AppRoutes, SearchTypes} from "../../utils/constants";
import {Nav} from "react-bootstrap";
import Tab from "react-bootstrap/Tab";


import LightGallery from 'lightgallery/react';
// import plugins if you need
import lgThumbnail from 'lightgallery/plugins/thumbnail';
import lgZoom from 'lightgallery/plugins/zoom';
import CourseCell from "../../components/course-cell";
import CourseDetailModal from "../../components/course-detail-modal";
import EventSchedule from "../../components/event-schedule";
import {useNotifyEventsService} from "../../services/notify-events-service";
import {useAuth} from "../../context/auth";


export default function TrainerDetail () {
    const [loaded, setLoaded] = useState(false);
    const [trainer, setTrainer] = useState(null);
    const [photos, setPhotos] = useState(null);
    const [videos, setVideos] = useState(null);
    const [courses, setCourses] = useState(null);
    const [events, setEvents] = useState(null);
    const [showLoadMore, setShowLoadMore] = useState(false);

    const {addErrorMessage} = useGlobalNotificationMessage();
    const favouriteService = useFavouritesService();
    const trainerService = useTrainerService();
    const nes = useNotifyEventsService();
    const {id} = useParams();
    const auth = useAuth();

    const courseDetailModalRef = useRef();

    useEffect(() => {
        if (id){
            let promises = [
                trainerService.getDetail(id),
                trainerService.getCourses(id),
                trainerService.getEvents(id, {upcoming: true}),
            ];

            Promise.all(promises).then(async ([_trainer, _courses, _events]) => {
                setTrainer(_trainer || null);
                setCourses(_courses?.courses || []);
                setEvents(_events || []);
                if (_events?.length>=20){
                    setShowLoadMore(true);
                }

                let photos = _trainer?.trainer?.gallery.filter((i)=>i.type==='PHOTO');
                let videos = _trainer?.trainer?.gallery.filter((i)=>i.type==='VIDEO');
                setPhotos(photos);
                setVideos(videos);

                setLoaded(true);
            }).catch(error => {
                HelperService.handleApiErrors(error, addErrorMessage);
            });

            nes.on(AppEvents.attendanceChanged, reloadEventDetail);
        }
    }, [id]);

    function reloadEventDetail(){
        trainerService.getEvents(id, {upcoming: true}).then((_events) => {
            setEvents(_events || []);
            if (_events?.length>=20){
                setShowLoadMore(true);
            }
        }).catch(error => {
            HelperService.handleApiErrors(error, addErrorMessage);
        });
    }

    function loadMoreClasses(){
        trainerService.getEvents(id, {upcoming: true, from: events[events.length-1].datetime})
            .then((_events) => {
                let idSet = new Set(events.map(event => event.id));
                _events = _events.filter(event => !idSet.has(event.id));
                setEvents([...events, ..._events] );
                if (_events?.length>=20){
                    setShowLoadMore(true);
                } else {
                    setShowLoadMore(false);
                }
            }).catch(error => {
                HelperService.handleApiErrors(error, addErrorMessage);
            });
    }

    const toggleLikeTrainer = function (t){
        if (t.trainer.liked){
            favouriteService
                .unlikeTrainer(t.id)
                .then(() => {
                    let newTrainer = Object.assign({}, t);
                    newTrainer.trainer = Object.assign({}, t.trainer, {liked: false});
                    setTrainer(newTrainer);
                })
                .catch(error => {
                    HelperService.handleApiErrors(error, addErrorMessage);
                });
        } else {
            favouriteService
                .likeTrainers([t.id])
                .then(() => {
                    let newTrainer = Object.assign({}, t);
                    newTrainer.trainer = Object.assign({}, t.trainer, {liked: true});
                    setTrainer(newTrainer);
                })
                .catch(error => {
                    HelperService.handleApiErrors(error, addErrorMessage);
                });
        }
    }

    return (
        <>

            {!loaded && <Section animation={HelperService.getRandomAnimation()} className="position-relative section-padding-first">
                <div className={"container"}>
                    <div className={"row"}>
                        <div className={"col-sm-12"}>
                            <InitialLoading />
                        </div>
                    </div>
                </div>
            </Section>}

            {loaded && <Section animation={HelperService.getRandomAnimation()} className="position-relative section-padding-first">
                <div className={"container"}>
                    <div className={"row"}>
                        <div className={"col-sm-12"}>

                            {!trainer?.trainer && <>
                                <h1 className="header-stripe-blue">Trainer detail</h1>
                                <p>Info about trainer</p>
                                <h2>:( we were not able to find the trainer you were looking for.</h2>
                                <p>Try searching for him from home screen</p>
                            </>}

                            {trainer?.trainer && <>
                                <div className="row">
                                    <div className="col-sm-12 col-md-6 col-lg-4">
                                        <div className="card ps-0 p-2 mb-4 border-0">
                                            <div className="d-flex flex-row gap-3">
                                                <div className="rounded-circle bg-cover flex-shrink-0"
                                                     style={{backgroundImage: `url(${trainer.photo})`, width: '90px', height: '90px'}}></div>
                                                <div className="px-2 w-100" style={{minWidth: 0}}>
                                                    <h6 className="mb-1">{trainer.name} {trainer.surname}</h6>
                                                    <div className="text-secondary fs-7 mb-1">
                                                        {trainer.trainer.classes === 0 && <span>No upcoming events</span>}
                                                        {trainer.trainer.classes > 0 && <span>Upcoming {trainer.trainer.classes} events</span>}
                                                    </div>
                                                    <StarRating rating={trainer.trainer.rating} count={trainer.trainer.reviews} showCount={true} />
                                                    {trainer.id!==auth.currentUser.id && <button
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            toggleLikeTrainer(trainer);
                                                        }}
                                                        className={`btn btn-sm mt-2 ${trainer.trainer.liked ? 'btn-outline-primary' : 'btn-primary'}`}>
                                                        {trainer.trainer.liked ? 'Following' : 'Follow'}
                                                    </button>}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-sm-12 col-md-6 col-lg-4">
                                        <div className="card p-4 mb-4 border-0 text-center">
                                            <div className="d-flex gap-4 align-items-center justify-content-center">
                                                {trainer?.location?.city && <div>
                                                    {trainer?.location?.city}
                                                    <div className="text-secondary fs-8">Based in</div>
                                                </div>}
                                                {trainer?.trainer?.followersCount > 0 && <div>
                                                    {trainer?.trainer?.followersCount}
                                                    <div className="text-secondary fs-8">Followers</div>
                                                </div>}
                                            </div>
                                            <div className="d-flex gap-3 align-items-center justify-content-center mt-3 flex-wrap">
                                                {trainer?.trainer?.mobile && <div className="router-link">
                                                    <Link to={`tel:${trainer?.trainer?.mobile}`} target="instagram"><button type="button" className="btn btn-outline-light text-primary"><span className="mdi mdi-cellphone fs-5"></span></button></Link>
                                                </div>}
                                                {trainer?.email && <div className="router-link">
                                                    <Link to={`mailto:${trainer?.email}`} target="instagram"><button type="button" className="btn btn-outline-light text-primary"><span className="mdi mdi-email-outline fs-5"></span></button></Link>
                                                </div>}
                                                {trainer?.trainer?.facebook && <div className="router-link">
                                                    <Link to={`https://www.facebook.com/${trainer?.trainer?.facebook}/`} target="instagram"><button type="button" className="btn btn-outline-light text-primary"><span className="mdi mdi-facebook fs-5"></span></button></Link>
                                                </div>}
                                                {trainer?.trainer?.twitter && <div className="router-link">
                                                    <Link to={`https://www.x.com/${trainer?.trainer?.twitter}/`} target="instagram"><button type="button" className="btn btn-outline-light text-primary"><span className="mdi mdi-twitter fs-5"></span></button></Link>
                                                </div>}
                                                {trainer?.trainer?.instagram && <div className="router-link">
                                                    <Link to={`https://www.instagram.com/${trainer?.trainer?.instagram}/`} target="instagram"><button type="button" className="btn btn-outline-light text-primary"><span className="mdi mdi-instagram fs-5"></span></button></Link>
                                                </div>}
                                                {trainer?.trainer?.otherLink && <div className="router-link">
                                                    <Link to={`${trainer?.trainer?.otherLink}/`} target="otherlink"><button type="button" className="btn btn-outline-light text-primary"><span className="mdi mdi-web fs-5"></span></button></Link>
                                                </div>}
                                            </div>
                                        </div>
                                    </div>
                                </div>


                                <div className="fixed-tabs-nav">
                                    <Tab.Container defaultActiveKey="schedule">
                                        <Nav variant="pills" className="">
                                            <Nav.Item>
                                                <Nav.Link eventKey="schedule">Schedule</Nav.Link>
                                            </Nav.Item>
                                            {trainer?.trainer?.availability?.enabled &&
                                                <Nav.Item>
                                                    <Nav.Link eventKey="bookme">Book me</Nav.Link>
                                                </Nav.Item>
                                            }
                                            <Nav.Item>
                                                <Nav.Link eventKey="templates">Templates</Nav.Link>
                                            </Nav.Item>
                                            <Nav.Item>
                                                <Nav.Link eventKey="bio">Bio</Nav.Link>
                                            </Nav.Item>
                                        </Nav>

                                        <Tab.Content className="mt-3">
                                            <Tab.Pane eventKey="schedule">
                                                <div className="card shadow rounded-3">
                                                    <div className="card-body p-sm-2 p-md-4 py-5">
                                                        {events?.length === 0 &&
                                                            <div className="col-sm-12 col-md-6 mb-5">
                                                                <h5>No planned events.</h5>
                                                                <p>FitPro doesn't have any planned events that we know of.</p>
                                                            </div>
                                                        }
                                                        <EventSchedule mode="trainerDetail" events={events} trainer={trainer} link={`${AppRoutes.events.path}/EID`} classes={'cell-hover-effect-subtle'} />
                                                        {showLoadMore && <div className="text-center"><button className="btn btn-outline-primary my-2" onClick={()=>loadMoreClasses()}>Load more events</button></div>}
                                                    </div>
                                                </div>
                                            </Tab.Pane>
                                            {trainer?.trainer?.availability?.enabled &&
                                                <Tab.Pane eventKey="bookme">
                                                    <div className="card shadow rounded-3">
                                                        <div className="card-body p-4 py-5">
                                                            {trainer?.trainer?.availability?.days?.length === 0 && <>
                                                                <div className="col-sm-12 col-md-6 mb-5">
                                                                    <h5>No free slots.</h5>
                                                                    <p>FitPro doesn't have any open spots that we know of.</p>
                                                                </div>
                                                            </>}
                                                            {trainer?.trainer?.availability?.days?.length > 0 && <>
                                                                <div className="row">
                                                                    <div className="col-sm-12 col-md-6 mb-2">
                                                                        <div className="row">
                                                                            {trainer?.trainer?.availability?.days.map(t => <div key={t.day} className="col-sm-12 col-md-6 mb-2">
                                                                                    <div className="card rounded-2">
                                                                                        <div className="card-header text-capitalize">{t.day.toLocaleLowerCase()}</div>
                                                                                        <div className="card-body">
                                                                                            {t?.intervals?.length>0 && t?.intervals.map((time, i) => <div key={t.day+'_'+i} className="col-sm-12 mb-2">
                                                                                                {time.from} - {time.to}
                                                                                            </div>)
                                                                                            }
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            )}
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-sm-12 col-md-6 mb-2">
                                                                        <p className="mb-2">You can contact the FitPro using his email, phone or social networks.</p>
                                                                        <p className="text-secondary">Please note that the schedule above is tentative.<br />Contact the FitPro for confirmation.</p>
                                                                    </div>
                                                                </div>
                                                            </>}
                                                        </div>
                                                    </div>
                                                </Tab.Pane>
                                            }
                                            <Tab.Pane eventKey="templates">
                                                <div className="card shadow rounded-3">
                                                    <div className="card-body p-4 py-5">
                                                        <div className="row">
                                                            {courses?.length === 0 && <>
                                                                <div className="col-sm-12 col-md-6 mb-5">
                                                                    <h5>No courses yet.</h5>
                                                                    <p>FitPro is working on them!</p>
                                                                </div>
                                                            </>}
                                                            {courses?.length > 0 && <>
                                                                <CourseDetailModal ref={courseDetailModalRef} />
                                                                {courses.map(t => <div key={t.id} className="col-sm-12 col-md-6 mb-2">
                                                                        <div key={t.id} className={'p-3'}>
                                                                            <CourseCell course={t} callback={()=>courseDetailModalRef.current.openModal(t.id)}/>
                                                                        </div>
                                                                    </div>
                                                                )}
                                                            </>}
                                                        </div>
                                                    </div>
                                                </div>
                                            </Tab.Pane>
                                            <Tab.Pane eventKey="bio">
                                                <div className="card shadow rounded-3">
                                                    <div className="card-body p-4 py-5">
                                                        <div className="row">
                                                            <div className="col-sm-12 col-md-6 mb-5">
                                                                <h5>Info</h5>
                                                                <p>{trainer?.trainer?.info}</p>
                                                            </div>
                                                            <div className="col-sm-12 col-md-6 mb-5">
                                                                {trainer?.trainer?.categories?.length > 0 && <>
                                                                    <h5>Categories</h5>
                                                                    <div>
                                                                        {trainer?.trainer?.categories.map((c) => {
                                                                            return <Link
                                                                                key={c.id}
                                                                                to={`${AppRoutes.searchEvents.path}?keyword=${trainer.name + ' ' + trainer.surname}&type=${SearchTypes.discover}&categories=[${c.id}]`}>
                                                                                <button type="button" className="btn btn-sm btn-outline-primary me-1 mb-1">{c.name}</button>
                                                                            </Link>
                                                                        })}
                                                                    </div>
                                                                </>}
                                                            </div>
                                                            {photos?.length > 0 && <div className="col-sm-12 mb-5">
                                                                <h5>Photos</h5>
                                                                <LightGallery plugins={[lgThumbnail, lgZoom]} licenseKey={process.env.REACT_APP_LIGHT_GALLERY_LICENCE} selector={'.lg-item'}>
                                                                    <div className="row">
                                                                        {photos.map(t => <div key={t.id} className={'col-sm-12 col-md-3 col-lg-2'}>
                                                                            <div className={'card rounded-3 overflow-hidden mb-3'}>
                                                                                <a data-src={t.url} className="lg-item d-inline-block"  style={{height: "150px"}}>
                                                                                    <img src={t.url} alt="" className="img-fit"/>
                                                                                </a>
                                                                            </div>
                                                                        </div>)}
                                                                    </div>
                                                                </LightGallery>
                                                            </div>}
                                                            {trainer?.trainer?.certificates?.length > 0 && <div className="col-sm-12 mb-5">
                                                                <h5>Certificates</h5>
                                                                <LightGallery plugins={[lgThumbnail, lgZoom]} licenseKey={process.env.REACT_APP_LIGHT_GALLERY_LICENCE} selector={'.lg-item'}>
                                                                    <div className="row">
                                                                        {trainer?.trainer?.certificates.map(t => <div key={t.id} className={'col-sm-12 col-md-3 col-lg-2'}>
                                                                            <div className={'card rounded-3 overflow-hidden mb-3'}>
                                                                                <a data-src={t.url} className="lg-item d-inline-block"  style={{height: "150px"}}>
                                                                                    <img src={t.url} alt="" className="img-fit"/>
                                                                                </a>
                                                                            </div>
                                                                        </div>)}
                                                                    </div>
                                                                </LightGallery>
                                                            </div>}
                                                            {videos?.length > 0 && <div className="col-sm-12 mb-5">
                                                                <h5>Video</h5>
                                                                {videos.map(t => <div key={t.id} className={'card mx-2'} style={{height: "350px"}}>
                                                                    <video width="100%" height="350" poster={t.thumbnail || ''} controls preload="metadata">
                                                                        <source src={t.url} type="video/mp4"/>
                                                                    </video>
                                                                </div>)}
                                                            </div>}
                                                        </div>
                                                    </div>
                                                </div>
                                            </Tab.Pane>
                                        </Tab.Content>
                                    </Tab.Container>
                                </div>
                            </>}

                        </div>
                    </div>
                </div>
            </Section>}

        </>
    );
}

TrainerDetail.getLayout = function getLayout(page) {
    return (
        <MainLayout>
            {page}
        </MainLayout>
    )
}